/**
 * 라벨 (key, value) 텍스트를 정규화한다. 서버 canonical 규칙을 그대로 따른다.
 *
 * 서버는 라벨을 `strip().lower()` 한 canonical (key, value) 로 get-or-create 한다
 * (`service/dataset_configuration/write.py::_get_or_create_label`). 그래서 `Camera_Rig` 와
 * `camera_rig` 는 같은 축이고 ` Dual ` 과 `dual` 은 같은 값이다. 화면에서 "같은 라벨인가" 를
 * 판정하는 곳은 모두 이 함수를 써야 한다. 한 곳이라도 원문으로 비교하면 그곳만 다른 결과를
 * 내고, 사용자는 서로 모순되는 두 문장을 본다.
 */
export function normalizeLabelText(text: string): string {
  return text.trim().toLowerCase();
}
